'use client'

import { DashboardEvaluationsQuery } from '~/gql/graphql'
import { DashboardEvaluationTable } from './DashboardEvaluationTable'

export type DashboardEvaluation =
  DashboardEvaluationsQuery['dashboard']['evaluations'][number]

export function DashboardTable({
  evaluations,
  ownership = 'owned',
}: {
  evaluations: {
    owned: DashboardEvaluation[]
    shared: DashboardEvaluation[]
  }
  ownership?: 'owned' | 'shared' | 'archived'
}) {
  return (
    <DashboardEvaluationTable
      ownership={ownership}
      evaluations={evaluations?.[ownership] || []}
    />
  )
}
